module.exports = __webpack_public_path__ + "media/src/images/pulse_logo-abbf4c69fe0bf05e691a47ddd7876a8a.png";